import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MAX_VISIBLE = 3;

const TeamMembersRow = ({ projectId }) => {
  const [teamMembers, setTeamMembers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/projects/${projectId}/team-members-public`
        );
        const data = await response.json();

        if (!response.ok) {
          console.error("Error fetching team members:", data.message);
          return;
        }

        const enriched = await Promise.all(
          data.teamMembers.map(async (member) => {
            try {
              const imgRes = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/user/${encodeURIComponent(member.email)}/profile-image`
              );
              const imgData = await imgRes.json();
              return {
                ...member,
                profileImage: imgData.profileImage || "/person.png",
              };
            } catch {
              return {
                ...member,
                profileImage: "/person.png",
              };
            }
          })
        );

        const unique = [];
        const seen = new Set();
        for (const m of enriched) {
          if (!seen.has(m.email)) {
            unique.push(m);
            seen.add(m.email);
          }
        }

        setTeamMembers(unique);
      } catch (err) {
        console.error("❌ Team fetch error", err);
      }
    };

    fetchTeamMembers();
  }, [projectId]);

  const handleClick = (email) => {
    if (!email) return;
    const username = email.split("@")[0];
    navigate(`/${username}`);
  };

  const visibleMembers = teamMembers.slice(0, MAX_VISIBLE);
  const remaining = teamMembers.length - MAX_VISIBLE;

  return (
    <div className="relative h-10 flex items-center">
      {teamMembers.length === 0 ? (
        <div className="text-[10px] text-gray-400 italic ml-1">
          No members yet
        </div>
      ) : (
        <div className="flex -space-x-2 max-w-full overflow-hidden">
          {visibleMembers.map((member, index) => (
            <img
              key={index}
              src={member.profileImage}
              alt="Team Member"
              className="w-8 h-8 rounded-full border-2 border-white object-cover cursor-pointer hover:scale-105 transition"
              onClick={() => handleClick(member.email)}
              onError={(e) => (e.target.src = "/person.png")}
            />
          ))}
          {remaining > 0 && (
            <div className="w-8 h-8 rounded-full bg-gray-300 text-xs font-semibold text-gray-700 border-2 border-white flex items-center justify-center">
              +{remaining}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TeamMembersRow;
